var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "Shoppe",
      class: {
        "js-header-attached": _vm.scrollPosition > 90,
        "js-header-not-attached": _vm.scrollPosition <= 90
      }
    },
    [
      _c("ProductModal", {
        attrs: {
          chosenOption: _vm.chosenOption,
          product: _vm.modalProduct,
          show: _vm.isModalOpen
        },
        on: {
          closemodal: function($event) {
            return _vm.closeModal()
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "Shoppe__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          _vm._l(_vm.categories, function(category) {
            return _c(
              "button",
              {
                key: category.value,
                on: {
                  click: function($event) {
                    return _vm.selectCategory(category.value)
                  }
                }
              },
              [_vm._v(_vm._s(category.name))]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", [
          _c("span", [_vm._v("SORT BY:")]),
          _vm._v(" "),
          _c(
            "select",
            {
              on: {
                change: function($event) {
                  return _vm.sortProducts($event)
                }
              }
            },
            [
              _c("option", { attrs: { value: "-" } }, [_vm._v("-")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "asc" } }, [
                _vm._v("Price (low-high)")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "desc" } }, [
                _vm._v("Price (high-low)")
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "Shoppe__main" }, [
        _c("div", { staticClass: "separator" }),
        _vm._v(" "),
        _c("div", { staticClass: "Shoppe__products" }, [
          _c(
            "ul",
            { staticClass: "Shoppe__addon-products" },
            _vm._l(_vm.sortedProducts, function(product) {
              return _c(
                "li",
                { key: product.id },
                [
                  _c("ShoppeProduct", {
                    attrs: { product: product },
                    on: {
                      openmodal: function(sentProduct, option) {
                        return _vm.loadModal(sentProduct, option)
                      }
                    }
                  })
                ],
                1
              )
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "Shoppe__sales" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "Shoppe__products" }, [
            _c(
              "ul",
              { staticClass: "Shoppe__addon-products" },
              _vm._l(_vm.featuredProducts, function(product) {
                return _c(
                  "li",
                  { key: product.id },
                  [
                    _c("ShoppeProduct", {
                      attrs: { product: product },
                      on: {
                        openmodal: function(sentProduct, option) {
                          return _vm.loadModal(sentProduct, option)
                        }
                      }
                    })
                  ],
                  1
                )
              }),
              0
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/header_title.svg?v=1626116290"
        }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "desktop" }, [
        _vm._v(
          "\n        Shop our best selling products individually  to send as gifts (or for yourself!)\n      "
        )
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "mobile" }, [
        _vm._v("\n        Shop for you & shop gifts for them: ship items to "),
        _c("br"),
        _vm._v(" \n        multiple addresses all in one order\n      ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "Shoppe__sales-header" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/sunicon.svg?v=1626119252"
        }
      }),
      _vm._v(" "),
      _c("span", [_vm._v("HAVE A HAPPY DAY")]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/cherryicon.svg?v=1626119252"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }